import I from '../types.ts';

const pageScroll: I['pageScroll'] = function ({ target }) {
    const { scrollTop } = target as HTMLElement;

    this.setMenuState({ scrollTop });
};

export default pageScroll;
